// src/router/index.tsx

import { useRoutes, Navigate, Outlet } from "react-router-dom";
import { Layout } from "../layouts/Layout";
import { HomePage } from "../pages/HomePage";
import { LoginPage } from "../pages/LoginPage";
import AdminAreaPage from "../pages/AdminAreaPage";
import { AnalystPage } from "../pages/AnalystAreaPage";
import { ParentAreaPage } from "../pages/ParentAreaPage";
import { ChildrenPage } from "../pages/Children";
import { FormsPage } from "../pages/AnalystForms";
import { ChildDetails } from "../pages/ChildDetails";
import { AddChildPage } from "../pages/AddChildPage";
import { BehaviorAnalysis } from "../pages/BehaviorAnalysis"; // ודא שיש קובץ כזה
import { ChildNotesPage } from "../pages/ChildNotesPage";
import { ChildFormsPage } from "../pages/ChildFormsPage";
import LessonSummariesPage from "../pages/LessonSummariesPage";
import { ProfilePage } from "../pages/ProfilePage";
import GeneralSummaryPage from "../pages/GeneralSummaryPage"; // Import the new GeneralSummaryPage

import AuthGuard from "../auth/AuthGuard";
import GuestGuard from "../auth/guestGuard";
import { RoleType } from "../types/user.types";
import { Paths } from "./paths";
import { CompleteProfilePage } from "../pages/CompleteProfilePage";
import PackagesPage from "../pages/PackagesPage";


const Router = () => {
  const routes = useRoutes([
    {
  path: Paths.completeProfile,
  element: (
    <CompleteProfilePage />
  ),
},
    {
      path: "/",
      element: (
        <Layout>
          <Outlet />
        </Layout>
      ),
      children: [
        { path: Paths.home, element: <HomePage /> },

        {
          path: Paths.adminArea,
          element: (
            <AuthGuard roles={[RoleType.Admin]}>
              <AdminAreaPage />
            </AuthGuard>
          ),
        },

        {
          path: Paths.analystArea,
          element: (
            <AuthGuard roles={[RoleType.Analyst]}>
              <AnalystPage />
            </AuthGuard>
          ),
        },
        
        {
          path: Paths.analystProfile,
          element: (
            <AuthGuard roles={[RoleType.Analyst]}>
              <ProfilePage />
            </AuthGuard>
          ),
        },

        {
          path: Paths.analystChildren,
          element: (
            <AuthGuard roles={[RoleType.Analyst]}>
              <ChildrenPage />
            </AuthGuard>
          ),
        },

        {
          path: Paths.addChild,
          element: (
            <AuthGuard roles={[RoleType.Analyst]}>
              <AddChildPage />
            </AuthGuard>
          ),
        },

        {
          path: Paths.childDetailsById, // היה: "children/:id"
          element: (
            <AuthGuard roles={[RoleType.Analyst]}>
              <ChildDetails />
            </AuthGuard>
          ),
        },  
        {
          path: Paths.analystForms,
          element: (
            <AuthGuard roles={[RoleType.Analyst]}>
              <FormsPage />
            </AuthGuard>
          ),
        },

        {
          path: Paths.packages,
          element: (
            <AuthGuard roles={[RoleType.Analyst]}>
              <PackagesPage />
            </AuthGuard>
          ),
        },

        {
          path: Paths.parentArea,
          element: (
            <AuthGuard roles={[RoleType.Parent]}>
              <ParentAreaPage />
            </AuthGuard>
          ),
        },

        {
          path: Paths.behaviorAnalysis,
          element: (
            <AuthGuard roles={[RoleType.Analyst]}>
              <BehaviorAnalysis />
            </AuthGuard>
          ),
        },
        {
          path: Paths.childNotes,
          element: (
            <AuthGuard roles={[RoleType.Analyst]}>
              <ChildNotesPage />
            </AuthGuard>
          ),
        },
        {
          path: Paths.childForms,
          element: (
            <AuthGuard roles={[RoleType.Analyst]}>
              <ChildFormsPage />
            </AuthGuard>
          ),
        },
        {
          path: Paths.lessonSummaries,
          element: (
            <AuthGuard roles={[RoleType.Analyst]}>
              <LessonSummariesPage />
            </AuthGuard>
          ),
        },
        {
          path: Paths.generalSummary,
          element: (
            <AuthGuard roles={[RoleType.Analyst]}>
              <GeneralSummaryPage />
            </AuthGuard>
          ),
        },
      ],
    },

    {
      path: Paths.login,
      element: (
        <GuestGuard>
          <LoginPage />
        </GuestGuard>
      ),
    },

    {
      index: true,
      element: <Navigate to={`/${Paths.home}`} />,
    },

    {
      path: "*",
      element: (
        <h1 style={{ textAlign: "center", marginTop: "2rem" }}>
          404 - העמוד לא נמצא
        </h1>
      ),
    },
  ]);

  return routes;
};

export default Router;
